import { Disabilities, MaritalStatusEnum, Territories } from '@app/entities/enums/ptrab/irpf.enum';

export class Worker {
  maritalStatus!: MaritalStatusEnum;
  spouseNif!: string | null;
  reducedMobility!: boolean;
  disability!: Disabilities;
  geographicMobilityDate!: string;
}

export class PensionPayment {
  childAllowance!: number;
  alimony!: number;
  courtRulingDate!: string;
}

export class WorkerRelative {
  birthDate!: number;
  disability!: Disabilities;
  reducedMobility!: boolean;
}

export class Descendant extends WorkerRelative {
  adoptionDate!: number;
  soleCustody!: boolean;
}

export class Ancestor extends WorkerRelative {
  numberDescendantLiveTogether!: number;
}
export class IrpfModel {
  individual!: Worker;
  descendants!: Descendant[];
  ascendants!: Ancestor[];
  pensionPayment!: PensionPayment;
  mortgageReduction!: boolean;
  ceutaMelillaResidence!: boolean;
  territory!: Territories;

  isCommonTerritory() {
    return this.territory && this.territory === Territories.COMMON_TERRITORY;
  }

  isNavarraTerritory() {
    return this.territory && this.territory === Territories.NAVARRA_TERRITORY;
  }

  isArabaTerritory() {
    return this.territory && this.territory === Territories.ARABA_TERRITORY;
  }

  isBizkaiaTerritory() {
    return this.territory && this.territory === Territories.BIZKAIA_TERRITORY;
  }

  isGipuzkoaTerritory() {
    return this.territory && this.territory === Territories.GIPUZKOA_TERRITORY;
  }

  isEuskalTerritory() {
    return this.isArabaTerritory() || this.isBizkaiaTerritory() || this.isGipuzkoaTerritory();
  }
}
